import React from 'react';
import { Popup, Button } from 'semantic-ui-react';
import { INVERTED_THEME } from '../../../utils/constants';
import styles from './PopupButton.styles';
import { POPUP_BUTTON, POPUP_BUTTON_POPUP } from './PopupButton.testIds';
import PropTypes from 'prop-types';

const PopupButton = ({
  popupText,
  position,
  popupOpen,
  ...props
}) => (
  <Popup
    data-testid={POPUP_BUTTON_POPUP}
    open={popupOpen}
    inverted={INVERTED_THEME}
    style={styles.popup}
    trigger={(
      <Button
        data-testid={POPUP_BUTTON}
        {...props} />
    )}
    on='hover'
    position={position}>
    {popupText}
  </Popup>
);

PopupButton.propTypes = {
  popupText: PropTypes.string,
  popupOpen: PropTypes.bool,
  position: Popup.propTypes.position,
  ...Button.propTypes
};

PopupButton.displayName = 'PopupButton';

export default PopupButton;